import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../assets/meltingface.svg'


const _hoisted_1 = { class: "design" }
const _hoisted_2 = { class: "d_tabs" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "content-list" }
const _hoisted_5 = { class: "image-group" }
const _hoisted_6 = ["src", "alt"]

import { ref } from 'vue';
import content from '../data/designproduct.json';

// 타입 정의
interface ContentItem {
  title: string;
  images: string[];
}
interface ContentData {
  [key: string]: ContentItem[];
}

// 탭 목록: 실제 JSON 키와 라벨 분리

export default /*@__PURE__*/_defineComponent({
  __name: 'DesignView',
  setup(__props) {

const tabs = [
  { key: 'blog', label: '블로그' },
  { key: 'popup', label: '팝업' },
  { key: 'cardnews', label: '카드뉴스' },
  { key: 'homepage', label: '홈페이지' },
  { key: 'xbanner', label: 'X배너ㆍ현수막' },
  { key: 'namecard', label: '명함ㆍ사원증' },
  { key: 'booklet', label: '시술책자' },
  { key: 'event', label: '이벤트(a4)' }
];

const selectedTab = ref('blog');

const contentTyped = ref(content as ContentData);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "d_title" }, [
      _createElementVNode("h3", null, "Design products"),
      _createElementVNode("img", {
        src: _imports_0,
        alt: "디자인이모지"
      })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (tab) => {
        return _createElementVNode("button", {
          key: tab.key,
          class: _normalizeClass({ active: selectedTab.value=== tab.key }),
          onClick: ($event: any) => (selectedTab.value = tab.key)
        }, _toDisplayString(tab.label), 11, _hoisted_3)
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contentTyped.value[selectedTab.value], (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "content-item",
          key: item.title
        }, [
          _createElementVNode("p", null, _toDisplayString(item.title), 1),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.images, (img, index) => {
              return (_openBlock(), _createElementBlock("img", {
                key: index,
                src: `/img/${img}`,
                alt: item.title
              }, null, 8, _hoisted_6))
            }), 128))
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})